// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ce-inline-tool--linkopen {
  display: none;
}

.ce-inline-tool-linkopen {
  display: none;
  margin: 0 -10px 10px 10px;
  margin-top: -10px;
  padding: 3px 5px;
  font-size: 13px;
}

.ce-inline-tool-linkopen--showed {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/utils/editorjs/inline-tools/link-open/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ce-inline-tool--linkopen {\n  display: none;\n}\n\n.ce-inline-tool-linkopen {\n  display: none;\n  margin: 0 -10px 10px 10px;\n  margin-top: -10px;\n  padding: 3px 5px;\n  font-size: 13px;\n}\n\n.ce-inline-tool-linkopen--showed {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
